import { render, staticRenderFns } from "./TheNotificationDrawer.vue?vue&type=template&id=66e5aecc&"
import script from "./TheNotificationDrawer.vue?vue&type=script&lang=ts&"
export * from "./TheNotificationDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports